import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nin',
  templateUrl: './nin.component.html',
  styleUrls: ['./nin.component.css']
})
export class NinComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
